<template>
  <button
    disabled
    title="Recording is stopped"
    v-tippy><font-awesome-icon :icon="faStop" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faStop } from '@fortawesome/pro-light-svg-icons/faStop'

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faStop
      }
    }
  }
</script>



// WEBPACK FOOTER //
// recording-stopped-label.vue?6a66ded9